export enum InflationOptions {
    disable = "disable",
    enable_for_all_goals = "enable_for_all_goals",
    enable_per_individual_goal = "enable_per_individual_goal"
}

export interface InflationOptionsType {
    TYPE: string,
    DISPLAY: string
}